/**
 * @generated SignedSource<<ef58a76848ffd918861569ca86dc4c79>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectRelatedSearchesContainer_viewer$data = {
  readonly photosSearchBrowseQuery: {
    readonly facets: {
      readonly imageRoomTypeFacet: ReadonlyArray<{
        readonly label: string | null;
        readonly name: string | null;
      } | null> | null;
      readonly imageStyleFacet: ReadonlyArray<{
        readonly label: string | null;
        readonly name: string | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "ProjectRelatedSearchesContainer_viewer";
};
export type ProjectRelatedSearchesContainer_viewer$key = {
  readonly " $data"?: ProjectRelatedSearchesContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectRelatedSearchesContainer_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectRelatedSearchesContainer_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": 1
        }
      ],
      "concreteType": "PhotosSearchBrowseQueryConnection",
      "kind": "LinkedField",
      "name": "photosSearchBrowseQuery",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowseFacets",
          "kind": "LinkedField",
          "name": "facets",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FacetValueType",
              "kind": "LinkedField",
              "name": "imageStyleFacet",
              "plural": true,
              "selections": (v0/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FacetValueType",
              "kind": "LinkedField",
              "name": "imageRoomTypeFacet",
              "plural": true,
              "selections": (v0/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "photosSearchBrowseQuery(first:1,page:1)"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "e6fde2543aa4034c29bf08fd562ab2bc";

export default node;
